import propTypeSchema from 'react-json-schema-proptypes'

export const Typography = {
  Schema: {
    'type': 'object',
    'properties': {
      'color': {'type': 'string'},
      'fontFamily': {'type': 'string'},
      'fontSize': {'type': 'string'},
      'textAlign': {'type': 'string'},
      'lineHeight': {'type': 'string'},
      'paddingTop': {'type': 'string'},
      'paddingRight': {'type': 'string'},
      'whiteSpace': {'type': 'string'},
      'display': {'type': 'string'},
      'background': {'type': 'string'},
      'borderTop': {'type': 'string'},
      'marginLeft': {'type': 'string'}
    }
  }
}

Typography.Props = propTypeSchema(Typography.Schema)

export const Amount = {
  Schema: {
    'type': 'object',
    'required': ['amount'],
    'properties': {
      'text': {'type': 'string'},
      'amount': {'type': 'number'},
      'type': {'type': 'string', 'enum': ['standard', 'custom']},
      'frequency': {'type': 'string', 'enum': ['one-time', 'monthly']}
    }
  }
}

Amount.Props = propTypeSchema(Amount.Schema)

export const Project = {
  Schema: {
    'type': 'object',
    'required': ['name', 'id'],
    'properties': {
      id: {'type': 'string'},
      name: {'type': 'string'},
      hasQuestion: {'type': 'boolean'},
      questionLabel: {'type': 'string'},
      hideProject: {'type': 'boolean'}
    }
  }
}

Project.Props = propTypeSchema(Project.Schema)

export const BasicDonorInfo = {
  Schema: {
    'type': 'object',
    'properties': {
      'firstName': {'type': 'string'},
      'lastName': {'type': 'string'},
      'email': {'type': 'string'},
      'mobileNumber': {'type': 'string'}
    }
  }
}

export const CompleteDonorInfo = {
  Schema: {
    'type': 'object',
    'properties': {
      'firstName': {'type': 'string'},
      'lastName': {'type': 'string'},
      'email': {'type': 'string'},
      'address': {'type': 'string'},
      'city': {'type': 'string'},
      'state': {'type': 'string'},
      'country': {'type': 'string'},
      'zip': {'type': 'string'},
      'mobileNumber': {'type': 'string'}
    }
  }
}

export const Address = {
  Schema: {
    'type': 'object',
    'properties': {
      'street': {'type': 'string'},
      'city': {'type': 'string'},
      'state': {'type': 'string'},
      'zipCode': {'type': 'string'}
    }
  }
}

export const Card = {
  Schema: {
    'type': 'object',
    'required': ['brand', 'customerId', 'id', 'last4'],
    'properties': {
      'brand': {'type': 'string'},
      'customerId': {'type': 'string'},
      'id': {'type': 'string'},
      'last4': {'type': 'string'}
    }
  }
}

export const Sidebar = {
  Schema: {
    'type': 'object',
    'properties': {
      'breakpoint': {'type': 'number'},
      'border': {'type': 'string'},
      'marginTop': {'type': 'string'}
    }
  }
}

export const PlainText = {
  Schema: {
    'type': 'object',
    'required': ['name'],
    'properties': {
      'name': {'type': 'string'}
    }
  }
}

export const DropDownOption = {
  Schema: {
    'type': 'object',
    'required': ['name', 'value'],
    'properties': {
      'name': {'type': 'string'},
      'value': {'type': 'string'}
    }
  }
}

export const Field = {
  Schema: {
    'type': 'object',
    'required': ['name', 'required'],
    'properties': {
      name: {'type': 'string'},
      dependencies: {'type': 'array', 'items': PlainText.Schema},
      optionalDependencies: {'type': 'array', 'items': PlainText.Schema},
      conditionallyRequired: {'type': 'array', 'items': PlainText.Schema},
      type: {
        'type': 'string',
        'enum': [ 'textField', 'checkBox', 'state', 'country', 'textArea', 'emailList', 'dropDown'],
      },
      label: {'type': 'string'},
      options: {'type': 'array', 'items': DropDownOption.Schema},
      withInfo: {'type': 'boolean'},
      infoStyle: Typography.Schema,
      infoTitle: {'type': 'string'},
      infoDesc: {'type': 'string'},
      labelStyle: Typography.Schema,
      formStyle: Typography.Schema,
      checkBoxText: {'type': 'string'},
      checkBoxTextStyle: Typography.Schema,
      checkBoxLink: {'type': 'array', 'items': PlainText.Schema},
      required: {'type': 'boolean'},
      hasModal: {'type': 'boolean'},
      modalText: {'type': 'string'},
      colMobile: {'type': 'number'},
      colDesktop: {'type': 'number'},
      astStyle: Typography.Schema,
      colStyle: Typography.Schema,
      colErrorStyle: Typography.Schema
    }
  }
}

export const SubscribeExtraFields = {
  Schema: {
    'type': 'object',
    'required': ['name', 'required'],
    'properties': {
      name: {'type': 'string'},
      options: {'type': 'array', 'items': PlainText.Schema},
      type: {'type': 'string', 'enum': ['textField', 'dropdown','state']},
      label: {'type': 'string'}
    }
  }
}
